'use es6';

import PropTypes from 'prop-types';
import { Component } from 'react';
import styled from 'foundations-theming/utils';
import colr from './vendor/colr';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function rgbaColor(r, g, b, a) {
  return `rgba(${[r, g, b, a / 100].join(',')})`;
}
const Slider = styled.div.withConfig({
  displayName: "AlphaRibbon__Slider",
  componentId: "hh3opw-0"
})(({
  theme
}) => ({
  position: 'relative',
  height: '14px',
  width: '100%',
  borderRadius: theme.borderRadius['100'],
  marginTop: theme.space['100'],
  backgroundImage: 'url(data:image/png;base64,R0lGODdhCgAKAPAAAOXl5f///ywAAAAACgAKAEACEIQdqXt9GxyETrI279OIgwIAOw==)',
  backgroundRepeat: 'repeat',
  userSelect: 'none'
}));
const SliderBackground = styled.div.withConfig({
  displayName: "AlphaRibbon__SliderBackground",
  componentId: "hh3opw-1"
})(({
  theme,
  $background
}) => ({
  position: 'absolute',
  width: '100%',
  height: '100%',
  borderRadius: theme.borderRadius['100'],
  boxShadow: '0 0 2px #808080 inset',
  background: $background
}));
const SliderIndicator = styled.span.withConfig({
  displayName: "AlphaRibbon__SliderIndicator",
  componentId: "hh3opw-2"
})(({
  theme,
  $left
}) => ({
  position: 'absolute',
  top: '2px',
  bottom: '2px',
  width: '6px',
  border: `${theme.borderWidth['100']} solid #888888`,
  padding: `${theme.space['25']} ${theme.space['0']}`,
  marginLeft: `-3px`,
  backgroundColor: '#eeeeee',
  borderRadius: theme.borderRadius['100'],
  left: $left
}));
const SliderHandler = styled.div.withConfig({
  displayName: "AlphaRibbon__SliderHandler",
  componentId: "hh3opw-3"
})(({
  theme
}) => ({
  position: 'absolute',
  width: '104%',
  height: '100%',
  left: '-2%',
  borderRadius: theme.borderRadius['100'],
  cursor: 'pointer'
}));
export default class AlphaRibbon extends Component {
  constructor(...args) {
    super(...args);
    this.onMouseDown = evt => {
      evt.preventDefault();
      const x = evt.clientX;
      const y = evt.clientY;
      this.pointMoveTo({
        x,
        y
      });
      window.addEventListener('mousemove', this.onDrag);
      window.addEventListener('mouseup', this.onDragEnd);
    };
    this.onDrag = evt => {
      const x = evt.clientX;
      const y = evt.clientY;
      this.pointMoveTo({
        x,
        y
      });
    };
    this.onDragEnd = evt => {
      const x = evt.clientX;
      const y = evt.clientY;
      this.pointMoveTo({
        x,
        y
      });
      this.removeMouseListeners();
    };
    this.getBackground = () => {
      const {
        r,
        g,
        b
      } = colr.fromHex(this.props.hex).toRgbObject();
      const startColor = rgbaColor(r, g, b, 0);
      const endColor = rgbaColor(r, g, b, 100);
      return `linear-gradient(to right, ${startColor}, ${endColor})`;
    };
    this.pointMoveTo = coords => {
      const rect = this.measureBounds();
      const width = rect.width;
      let left = coords.x - rect.left;
      left = Math.max(0, left);
      left = Math.min(left, width);
      const alpha = Math.floor(left / width * 100);
      this.props.onChange({
        alpha
      });
    };
  }
  componentWillUnmount() {
    this.removeMouseListeners();
  }
  removeMouseListeners() {
    window.removeEventListener('mousemove', this.onDrag);
    window.removeEventListener('mouseup', this.onDragEnd);
  }
  measureBounds() {
    return this.slider && this.slider.getBoundingClientRect();
  }
  render() {
    const {
      alpha
    } = this.props;
    return /*#__PURE__*/_jsxs(Slider, {
      ref: el => this.slider = el,
      "data-test-id": "alpha-ribbon-slider",
      children: [/*#__PURE__*/_jsx(SliderBackground, {
        "data-test-id": "alpha-ribbon-background",
        $background: this.getBackground()
      }), /*#__PURE__*/_jsx(SliderIndicator, {
        "data-test-id": "alpha-ribbon-slider-indicator",
        $left: `${alpha}%`
      }), /*#__PURE__*/_jsx(SliderHandler, {
        "data-test-id": "alpha-ribbon-handler",
        onMouseDown: this.onMouseDown
      })]
    });
  }
}
AlphaRibbon.propTypes = {
  alpha: PropTypes.number,
  hex: PropTypes.string,
  onChange: PropTypes.func
};